import { randomUUID } from "@warrenio/utils/ponyfill/randomUUID";
import { useMemo } from "react";

export function useGenerateUuid(existingUuid?: string | null) {
    return useMemo(() => existingUuid ?? randomUUID(), [existingUuid]);
}
